// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"3c1da02c","366":"e814d7a9","680":"63997482","846":"4734015c","974":"b9395bf7"}[chunkId] + ".chunk.js";
};